import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';

import {axios as http} from './apis/base'
import myUrl from './apis/myurl'

Vue.use(Vant);
Vue.config.productionTip = false

Vue.prototype.$myUrl = myUrl
Vue.prototype.$myGetHttp = function (url,params) {
  return http.get(url,{params:params})
}
Vue.prototype.$myPostHttp = function (url,params) {
  return http.post(url,params)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


